import { MdOutlineEdit, MdOutlineDeleteOutline } from "react-icons/md";
import "./adminRowActions.css";

// The one row-actions implementation for table action columns - every
// list page previously hand-rolled its own edit/delete icons with no
// accessible name at all.
export const AdminRowActions = ({ label, onEdit, onDelete, extra }) => (
  <div className="admin-row-actions">
    {extra}
    {onEdit && (
      <button
        type="button"
        className="admin-row-actions__btn"
        onClick={onEdit}
        aria-label={label ? `Edit ${label}` : "Edit"}
      >
        <MdOutlineEdit />
      </button>
    )}
    {onDelete && (
      <button
        type="button"
        className="admin-row-actions__btn admin-row-actions__btn--danger"
        onClick={onDelete}
        aria-label={label ? `Delete ${label}` : "Delete"}
      >
        <MdOutlineDeleteOutline />
      </button>
    )}
  </div>
);
